const GET_WANTED_MOVIES = "GET_WANTED_MOVIES";
const GET_SEEN_MOVIES = "GET_SEEN_MOVIES";
const ADD_WANTED_MOVIE = "ADD_MOVIE";
const REMOVE_WANTED_MOVIE = "REMOVE_MOVIE";
const SEEN_MOVIE = "SEEN_MOVIE";
const UNSEEN_MOVIE = "UNSEEN_MOVIE";

export {
  GET_WANTED_MOVIES,
  GET_SEEN_MOVIES,
  ADD_WANTED_MOVIE,
  REMOVE_WANTED_MOVIE,
  SEEN_MOVIE,
  UNSEEN_MOVIE,
};
